import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import ButtonPrimary from '../../Form/ButtonPrimary';
import { useCartContext } from '../../../Contexts/CartContext';
import CardProductCartConference from './CardProductCartConference';
import { TbShoppingBagPlus, TbTrash } from 'react-icons/tb';
import Modal from '../Modal';
import EditObservationConference from '../Product/EditObservationConference';
import { useStoreHook } from '../../../Hooks/StoreHook';
import Confirm from '../Confirm';
import { useCartHook } from '../../../Hooks/CartHook';
import BoxContentConfirmTable from './BoxContentConfirmTable';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import { useOrderTypeContext } from '../../../Contexts/OrderTypeContext';
import { useStoreContext } from '../../../Contexts/StoreContext';
import CartService from '../../../Services/CartService';
import { useTranslation } from 'react-i18next';

interface CartConferenceProps {
    cart: any;
    onCloseCart: CallableFunction;
}

const CartConference = ({cart, onCloseCart}: CartConferenceProps) => {

    const { t } = useTranslation();
    const { cartDisplay, setCartDisplay, deleteProductFromConference, updateProductInConference, updateObservationProductInConference, setCartConference, setShowCartConference, setShowConfirmTable } = useCartContext();
    const { isCartInfoViewed, setIsCartInfoViewed, setMainLoading, setMainLoadingIcon, setMainLoadingIconError, setMainLoadingTitle, setMainLoadingMessage, setMainLoadingCloseButton, enabledCartLoad, setEnabledCartLoad } = useLayoutContext();
    const [showEditProduct, setShowEditProduct] = useState(false);
    const [showConfirmResetCartConference, setShowConfirmResetCartConference] = useState(false);
    const [currentProductToEdit, setCurrentProductToEdit] = useState<any>(null);
    const { storeIsOpen } = useStoreHook();
    const { handleSend } = useCartHook();
    const { isStoreCounter, getOrderTypeIdByName, orderType } = useOrderTypeContext();
    const { currentStore } = useStoreContext();
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        if (isStoreCounter) {
            const getShowCart = async () => {
                const payload = {
                    cart_id: cartDisplay.id,
                    store_id: currentStore.id,
                    order_type: Number(getOrderTypeIdByName(orderType)),
                }
                try {
                    setLoading(true);
                    const cartService = new CartService(orderType);
                    let responseCartShow = await cartService.show(payload);

                    if (responseCartShow) {
                        setCartDisplay({
                            ...cartDisplay,
                            table: {
                                id: responseCartShow.table?.id,
                                name: responseCartShow.table?.name,
                            },
                        });
                    }
                }
                catch (error: any) {
                    setMainLoadingIcon(false);
                    setMainLoadingIconError(true);
                    setMainLoading(true);
                    setMainLoadingTitle(t('errors.default_title'));
                    setMainLoadingMessage(t('store_counter.table_choice.error_checking_table'));
                    setMainLoadingCloseButton(true);
                }
                finally {setLoading(false)}
            }
            if (cartDisplay && enabledCartLoad) {
                getShowCart();
            }
            setEnabledCartLoad(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStoreCounter]);

    const handSendCheckTable = () => {
        if (cartDisplay.table.id) {
            handleSend();
            if (isCartInfoViewed === null) {
                setIsCartInfoViewed(false);
            }
        } else {
            handleChoiceTable()
        }
    }
    const handleChoiceTable = () => {
        //* Verificando horários de funcionamento
        if (storeIsOpen()) {
            setShowConfirmTable(true);
        }
    }
    const handleUpdate = (itemConferenceId: number, quantity: number) => {
        updateProductInConference(itemConferenceId, quantity);
    }

    const handleDelete = (itemConferenceId: number) => {
        deleteProductFromConference(itemConferenceId);
    }

    const handleCardClick = (product: any) => {
        setShowEditProduct(true);
        setCurrentProductToEdit(product);
    }

    const handleCancelEditProduct = () => {
        setShowEditProduct(false);
        setCurrentProductToEdit(null);
    }

    const handleConfirChangeEdit = (observation: string) => {
        updateObservationProductInConference(currentProductToEdit.itemConferenceId, observation);
        handleCancelEditProduct();
    }

    const handleResetCartConference = () => {
        setShowConfirmResetCartConference(false);
        setCartConference([]);
        setShowCartConference(false);
    }

    return (
        <section className='p-4 md:pb-4 pt-0 h-full'>

            <section className="flex flex-col justify-between h-full gap-4">
                <div className='flex flex-col gap-3 w-full h-full md:overflow-y-auto'>

                    <div className='h-full min-h-32 gap-10'>
                        <Scrollbars autoHide={true}>
                            <div className='flex flex-col divide-y divide-gray-100'>
                                {cart.map((product: any, index: number) =>
                                    <CardProductCartConference
                                        product={product}
                                        onDec={(quantity: number) => handleUpdate(product.itemConferenceId, quantity)}
                                        onInc={(quantity: number) => handleUpdate(product.itemConferenceId, quantity)}
                                        onDelete={() => handleDelete(product.itemConferenceId)}
                                        key={product.itemConferenceId}
                                        onCardClick={() => handleCardClick(product)}
                                    />
                                )}
                                {cart.length > 1 &&
                                    <div className='py-4 pr-2 text-right'>
                                        <button onClick={() => setShowConfirmResetCartConference(true)}
                                            className='inline-flex items-center justify-end gap-0.5 text-xs text-gray-400 hover:text-shopfood-danger font-medium transition-all'
                                            >
                                            <TbTrash /> {t('cart.button_remove_all_label')}
                                        </button>
                                    </div>
                                }
                            </div>
                        </Scrollbars>
                    </div>
                </div>

                <BoxContentConfirmTable
                    show={cartDisplay?.table.id}
                    tableName={cartDisplay?.table.name}
                    onClickConfirm={handleChoiceTable}
                    loading={loading}

                />

                <div className="flex gap-2 w-full">
                    <ButtonPrimary outline onClick={() => onCloseCart(false)} className='w-full gap-0.5'>
                        <div><TbShoppingBagPlus size={20} className='-mt-0.5' /></div>
                        <span>{t('cart_conference.button_add_product_label')}</span>
                    </ButtonPrimary>
                    <ButtonPrimary disabled={Boolean(loading)} onClick={handSendCheckTable} className='w-full gap-0.5'>
                        {t('cart_conference.button_send_label')}
                    </ButtonPrimary>
                </div>
            </section>

            {/* MODAL OBSERVACAO DO PRODUTO */}
            {currentProductToEdit &&
                <Modal open={showEditProduct} className="max-w-sm m-4" onClose={() => handleCancelEditProduct()}>
                    <EditObservationConference
                        product={currentProductToEdit}
                        onConfirm={(observation: string) => handleConfirChangeEdit(observation)}
                        onCancel={() => handleCancelEditProduct()}
                    />
                </Modal>
            }

            {/* MODAL CONFIRM RESET CONFERENCE CART */}
            <Modal open={showConfirmResetCartConference} className="max-w-md m-4" onClose={() => setShowConfirmResetCartConference(false)}>
                <Confirm
                    onConfirm={handleResetCartConference}
                    onCancel={() => setShowConfirmResetCartConference(false)}
                    title={t('cart.confirm_remove_all.title')}
                    message={t('cart.confirm_remove_all.message')}
                    labelConfirm={t('cart.confirm_remove_all.label_confirm')}
                />
            </Modal>

        </section>
    );
};

export default CartConference;
